import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=f131a09e"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports